import {FC} from "react";
import appleTouchIcon from '../../../assets/nps/icons/apple-touch-icon.png';
import favicon from '../../../assets/nps/icons/favicon-32x32.png';
import safariPinnedTab from '../../../assets/nps/icons/safari-pinned-tab.svg';
import {Helmet} from 'react-helmet';

interface NpsHeadProps {
    title?: string
}

const NpsHead: FC<NpsHeadProps> = ({title = ''}) => {
    return (
        <Helmet>
            <meta charSet="UTF-8"/>
            <meta content="IE=edge" http-equiv="X-UA-Compatible"/>
            <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
            <title>{title}</title>
            <link href={appleTouchIcon} rel="apple-touch-icon"
                  sizes="180x180"/>
            <link href={favicon} rel="icon" sizes="32x32"
                  type="image/png"/>
            <link href={require('../../../assets/nps/icons/site.webmanifest')} rel="manifest"/>
            <link color="#5bbad5"
                  href={safariPinnedTab}
                  rel="mask-icon"/>
            <meta content="#da532c" name="msapplication-TileColor"/>
            <meta content="#ffffff" name="theme-color"/>
        </Helmet>
    )
}

export default NpsHead;